import type { Locale } from '@wecasa/i18n';
import type { PreciseLocale } from '@wecasa/i18n/src/types';

import { SUPPORTED_LOCALES } from '../constants/country';
import type { Country } from '../types/country';

// Frontend uses Locale: `fr` for French in France, 'de-AT' for German in Austria
// Backend uses PreciseLocale: `fr-FR` for French in France, 'de-AT' for German in Austria
export const formatLocaleToPreciseLocale = ({ locale, country }: { locale: Locale; country: Country }) =>
  (locale.indexOf('-') === -1 ? `${locale}-${country}` : locale) as PreciseLocale;

// Frontend uses Locale: `fr` for French in France, 'de-AT' for German in Austria
// Backend uses PreciseLocale: `fr-FR` for French in France, 'de-AT' for German in Austria
export const formatPreciseLocaleToLocale = (preciseLocale: PreciseLocale): Locale => {
  if (SUPPORTED_LOCALES.includes(preciseLocale as Locale)) return preciseLocale as Locale;
  return preciseLocale.split('-')[0].toLowerCase() as Locale;
};
